/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Create a public API to a decorator for the n-th vipr dataset
 *
 * @class DecoratorAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'slots API',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events: {
						propagationInfo: {
							namespace: 'slots',
							callStack: {
								name:'getSlots'
							},
							info: {
								supportsUndoRedo: true,
								refresh: {
									predictSuggestions: true,
									keyDrivers: true,
									dataIfQueryChanged: true
								}
							}
						},
						actions: {
							'createDataItems': {
								eventName: 'dataitems:create',
								isResolvePostResponse: true,
								getInfo: (args) => {
									const refresh = {};
									// ensure to load the metadata when creating the first dataitem on the visualization
									if (this.getDataItemList().length === args[0].length) {
										refresh['metadata'] = true;
									}
									return {
										dataItemList: args[0],
										refresh
									};
								},
								getAction: (args, returnValue) => {
									// Include the id of the created dataItem in the action params.. so that we can recreate with the same id
									const dataItems = [];
									args[0].forEach((dataItem, index) => {
										dataItems.push({
											columnId: dataItem.columnId,
											id: returnValue[index].getId()
										});
									});
									return {
										params:[dataItems]
									};
								},
								getUndoActions: (args, result) => {
									const undoActions= [];
									const dataItemIds = result.map((dataItem) => dataItem.getId());
									undoActions.push({
										name: 'deleteDataItems',
										params:[dataItemIds]
									});
									return undoActions;
								}
							},
							'deleteDataItems': {
								eventName: 'dataitems:delete',
								getInfo: (args, result) => {
									return {
										dataItemList: result
									};
								},
								getUndoActions: (args) => {
									const undoActions = [];
									const resultActions = [];
									let ids = args[0];
									const undoParam = [];
									ids.forEach(id => {
										const dataItem = this.getDataItemImpl(id);
										if (dataItem) {
											undoParam.push({
												id: id,
												columnId: dataItem.getColumnId(),
												itemLabel: dataItem.getLabel(),
												navigationPathId: dataItem.getNavigationPathId()
											});
											resultActions.push(dataItem ? dataItem.serializeActions() : []);
										} else {
											//If the dataItem doesn't exist, the id should be eliminated - its a no-op.
											ids = ids.filter((thisId) => thisId!==id);
										}
									});

									if (undoParam.length) {
										const currentDataItems = this.getDataItemList();
										const dataSource = this.getDataSource();
										if(ids.length === currentDataItems.length && dataSource) {
											undoActions.push({
												callStack:[{
													name:'..'
												}],
												name:'setDataSource',
												params:[dataSource.getId()]
											});
										}

										undoActions.push({
											callStack: [{
												name:'getSlots'
											}],
											name: 'createDataItems',
											params:[undoParam],
											resultActions: resultActions
										});
									}
									return undoActions;
								}
							}
						}
					}

				};
			}
			return this.apiSpec;
		}
	}

	return APISpec;
});
